export enum SidebarType {
  ABSENCE = 'ABSENCE',
  ABSENCE_EDIT = 'ABSENCE_EDIT',
  EVENT = 'EVENT',
  EVENT_EDIT = 'EVENT_EDIT',
  BOOKING_EDIT = 'BOOKING_EDIT',
  BOOKING_CREATE = 'BOOKING_CREATE',
  FAST_CHECKIN = 'FAST_CHECKIN',
}
